(function () {
  'use strict';

  var WIDTHS = ['2', '3', '4', '5', '6', '7', '8', '9'];
  var LENGTHS = ['3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'];
  var COPY_DEFAULTS = {
    estimateUs: 'Your rug price estimate will be ${price}, and enjoy free shipping!',
    estimateIntl: 'Your rug price estimate will be ${price}. International shipping will be confirmed via email.',
    successUs: 'Your request has been successfully submitted. We\'ll be in touch within 7 business days with your custom rug quote and design.',
    successIntl: 'Your request has been successfully submitted. We\'ll be in touch within 7 business days. As you\'re outside the US mainland, our team will also confirm the shipping cost with you separately.'
  };

  function formatCopy(template, vars) {
    var s = template || '';
    Object.keys(vars).forEach(function (key) {
      s = s.split('{' + key + '}').join(vars[key]);
    });
    return s;
  }

  function getCopy(config, key) {
    if (config.copy && config.copy[key]) return config.copy[key];
    return COPY_DEFAULTS[key] || '';
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  var INTL_TEL_INPUT_CSS = 'https://cdn.jsdelivr.net/npm/intl-tel-input@25/build/css/intlTelInput.css';
  var INTL_TEL_INPUT_JS = 'https://cdn.jsdelivr.net/npm/intl-tel-input@25/build/js/intlTelInput.min.js';
  var PHONE_PATTERN = /^[\d\s()+-]{6,20}$/;
  var intlTelInputLoadPromise = null;

  function loadIntlTelInputAssets() {
    if (intlTelInputLoadPromise) return intlTelInputLoadPromise;

    intlTelInputLoadPromise = new Promise(function (resolve, reject) {
      if (!document.querySelector('link[data-custom-rug-intl-tel-css]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = INTL_TEL_INPUT_CSS;
        link.setAttribute('data-custom-rug-intl-tel-css', '');
        document.head.appendChild(link);
      }

      if (typeof window.intlTelInput === 'function') {
        resolve();
        return;
      }

      var existingScript = document.querySelector('script[data-custom-rug-intl-tel-js]');
      if (existingScript) {
        if (typeof window.intlTelInput === 'function') {
          resolve();
          return;
        }
        existingScript.addEventListener('load', function () { resolve(); }, { once: true });
        existingScript.addEventListener('error', function () { reject(new Error('intl-tel-input failed to load')); }, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = INTL_TEL_INPUT_JS;
      script.defer = true;
      script.setAttribute('data-custom-rug-intl-tel-js', '');
      script.addEventListener('load', function () { resolve(); }, { once: true });
      script.addEventListener('error', function () { reject(new Error('intl-tel-input failed to load')); }, { once: true });
      document.body.appendChild(script);
    });

    return intlTelInputLoadPromise;
  }

  function CustomRugSizeModal(root) {
    this.root = root;
    this.overlay = document.querySelector('[data-custom-rug-overlay]');
    this.modal = document.querySelector('[data-custom-rug-modal]');
    this.form = document.getElementById('custom-rug-size-form');
    this.config = window.customRugSizeConfig || {};
    this.priceTable = {};
    this.currentStep = 'intro';
    this.isSubmitting = false;
    this.lastTrigger = null;
    this.addressDetails = null;
    this.addressSearchTimer = null;
    this.addressSearchRequestId = 0;
    this.phoneInput = null;
    this.fullPhoneInput = null;
    this.iti = null;

    this.init();
  }

  CustomRugSizeModal.prototype.init = function () {
    var self = this;

    if (!this.modal || !this.form) return;

    this.bindTriggers();
    this.bindModalEvents();
    this.initAddressSearch();
    this.populateSelects();
    this.loadPriceTable();
  };

  CustomRugSizeModal.prototype.bindTriggers = function () {
    var self = this;

    document.querySelectorAll('.custom-rug-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.lastTrigger = btn;
        self.open();
      });
    });
  };

  CustomRugSizeModal.prototype.bindModalEvents = function () {
    var self = this;

    this.overlay.addEventListener('click', function () {
      self.close();
    });

    this.modal.querySelectorAll('[data-custom-rug-close], [data-custom-rug-cancel]').forEach(function (el) {
      el.addEventListener('click', function () {
        self.close();
      });
    });

    var startBtn = this.modal.querySelector('[data-custom-rug-start]');
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        self.goToStep('form');
      });
    }

    var backBtn = this.modal.querySelector('[data-custom-rug-back]');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        self.hideSystemError();
        self.goToStep('intro');
      });
    }

    var gotItBtn = this.modal.querySelector('[data-custom-rug-got-it]');
    if (gotItBtn) {
      gotItBtn.addEventListener('click', function () {
        self.close();
      });
    }

    var faqToggle = this.modal.querySelector('[data-custom-rug-faq-toggle]');
    var faqPanel = this.modal.querySelector('[data-custom-rug-faq-panel]');
    var modalBody = this.modal.querySelector('.custom-rug-size-modal__body');
    if (faqToggle && faqPanel) {
      faqToggle.addEventListener('click', function () {
        var expanded = faqToggle.getAttribute('aria-expanded') === 'true';
        var scrollTop = modalBody ? modalBody.scrollTop : 0;

        faqToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        faqPanel.hidden = expanded;

        if (modalBody) {
          var lockScroll = function () {
            modalBody.scrollTop = scrollTop;
          };
          lockScroll();
          requestAnimationFrame(function () {
            lockScroll();
            requestAnimationFrame(lockScroll);
          });
        }
      });
    }

    var usMainland = this.form.querySelector('[data-custom-rug-us-mainland]');
    if (usMainland) {
      usMainland.addEventListener('change', function () {
        self.toggleAddressField();
        self.updateEstimate();
        self.hideAddressSuggestions();
      });
    }

    var addressInput = this.form.querySelector('[data-custom-rug-address-input]');
    if (addressInput) {
      addressInput.addEventListener('input', function () {
        self.addressDetails = null;
        self.queueAddressSearch(addressInput.value.trim());
      });

      addressInput.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          self.hideAddressSuggestions();
        }
      });
    }

    var addressSuggestions = this.form.querySelector('[data-custom-rug-address-suggestions]');
    if (addressSuggestions) {
      addressSuggestions.addEventListener('mousedown', function (e) {
        e.preventDefault();
      });
    }

    var lengthSelect = this.form.querySelector('[data-custom-rug-length]');
    var widthSelect = this.form.querySelector('[data-custom-rug-width]');
    if (lengthSelect) lengthSelect.addEventListener('change', function () { self.onSizeChange(); });
    if (widthSelect) widthSelect.addEventListener('change', function () { self.onSizeChange(); });

    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      self.submit();
    }, true);

    // Prevent programmatic form.submit() calls (e.g. from data-persist-bound scripts)
    this.form.submit = function () {};

    var submitBtn = this.getSubmitButton();
    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        self.submit();
      }, true);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.modal.classList.contains('is-active')) {
        self.close();
      }
    });
  };

  CustomRugSizeModal.prototype.loadPriceTable = function () {
    var self = this;
    var url = this.config.priceTableUrl;
    if (!url) return;

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        self.priceTable = data || {};
      })
      .catch(function () {
        self.priceTable = {};
      });
  };

  CustomRugSizeModal.prototype.populateSelects = function () {
    var lengthSelect = this.form.querySelector('[data-custom-rug-length]');
    var widthSelect = this.form.querySelector('[data-custom-rug-width]');

    if (lengthSelect) {
      LENGTHS.forEach(function (len) {
        var opt = document.createElement('option');
        opt.value = len;
        opt.textContent = len + "'";
        lengthSelect.appendChild(opt);
      });
    }

    if (widthSelect) {
      WIDTHS.forEach(function (w) {
        var opt = document.createElement('option');
        opt.value = w;
        opt.textContent = w + "'";
        widthSelect.appendChild(opt);
      });
    }
  };

  CustomRugSizeModal.prototype.ensurePhoneInput = function () {
    var self = this;
    loadIntlTelInputAssets()
      .then(function () {
        self.initPhoneInput();
      })
      .catch(function () {});
  };

  CustomRugSizeModal.prototype.initPhoneInput = function () {
    this.phoneInput = this.form.querySelector('[data-custom-rug-phone]');
    this.fullPhoneInput = this.form.querySelector('[data-custom-rug-full-phone]');
    if (!this.phoneInput || typeof window.intlTelInput !== 'function' || this.iti) return;

    var self = this;
    this.iti = window.intlTelInput(this.phoneInput, {
      initialCountry: 'us',
      preferredCountries: ['us', 'ca', 'gb', 'au'],
      separateDialCode: true,
      dropdownContainer: document.body,
      autoPlaceholder: 'aggressive',
      countrySearch: true,
      strictMode: false,
      loadUtils: function () {
        return import('https://cdn.jsdelivr.net/npm/intl-tel-input@25/build/js/utils.js');
      }
    });

    this.phoneInput.setAttribute('inputmode', 'tel');
    this.phoneInput.setAttribute('autocapitalize', 'off');
    this.phoneInput.setAttribute('autocorrect', 'off');
    this.phoneInput.setAttribute('spellcheck', 'false');

    var selectedCountry = this.form.querySelector('.custom-rug-size-field--phone .iti__selected-country');
    if (selectedCountry) {
      selectedCountry.style.touchAction = 'manipulation';
      selectedCountry.addEventListener('touchend', function (e) {
        e.preventDefault();
        e.stopPropagation();
        selectedCountry.click();
      }, { passive: false });
    }

    this.phoneInput.addEventListener('input', function () {
      self.enforcePhoneMaxDigits();
      self.validatePhoneField({ showError: false });
    });

    this.phoneInput.addEventListener('paste', function () {
      setTimeout(function () {
        self.enforcePhoneMaxDigits();
        self.validatePhoneField({ showError: false });
      }, 0);
    });

    this.phoneInput.addEventListener('blur', function () {
      self.validatePhoneField({ showError: true });
    });

    this.phoneInput.addEventListener('countrychange', function () {
      self.enforcePhoneMaxDigits();
      self.validatePhoneField({ showError: true });
    });

    if (this.iti.promise) {
      this.iti.promise.then(function () {
        self.itiUtilsReady = true;
        self.validatePhoneField({ showError: false });
      }).catch(function () {
        self.itiUtilsReady = false;
      });
    }
  };

  CustomRugSizeModal.prototype.getPhoneDigits = function () {
    if (!this.phoneInput) return '';
    return this.phoneInput.value.replace(/\D/g, '');
  };

  CustomRugSizeModal.prototype.getPhoneMaxDigits = function () {
    var country = this.iti && this.iti.getSelectedCountryData ? this.iti.getSelectedCountryData() : null;
    var iso2 = country && country.iso2 ? country.iso2.toLowerCase() : 'us';

    if (iso2 === 'us' || iso2 === 'ca') {
      return 10;
    }

    return 15;
  };

  CustomRugSizeModal.prototype.enforcePhoneMaxDigits = function () {
    if (!this.phoneInput) return;

    var maxDigits = this.getPhoneMaxDigits();
    var digits = this.getPhoneDigits();
    if (digits.length <= maxDigits) return;

    var truncated = digits.slice(0, maxDigits);
    if (this.iti) {
      this.iti.setNumber(truncated);
      return;
    }

    this.phoneInput.value = truncated;
  };

  CustomRugSizeModal.prototype.isPhoneValidBasic = function () {
    var digits = this.getPhoneDigits();
    if (!digits) return true;

    var country = this.iti && this.iti.getSelectedCountryData ? this.iti.getSelectedCountryData() : null;
    var iso2 = country && country.iso2 ? country.iso2.toLowerCase() : 'us';

    if (iso2 === 'us' || iso2 === 'ca') {
      return digits.length === 10;
    }

    return digits.length >= 6 && digits.length <= this.getPhoneMaxDigits();
  };

  CustomRugSizeModal.prototype.showPhoneFieldError = function () {
    var wrap = this.form.querySelector('[data-field="phone"]');
    if (wrap) wrap.classList.add('has-error');
    var phoneErr = this.form.querySelector('[data-field="phone"] .custom-rug-size-field__error--phone');
    if (phoneErr) phoneErr.hidden = false;
    if (this.phoneInput) this.phoneInput.setAttribute('aria-invalid', 'true');
  };

  CustomRugSizeModal.prototype.getFieldInput = function (field) {
    if (field === 'phone' && this.phoneInput) return this.phoneInput;

    var wrap = this.form.querySelector('[data-field="' + field + '"]');
    if (!wrap) return null;

    return wrap.querySelector(
      'input:not([type="hidden"]):not(.iti__search-input), select, textarea'
    );
  };

  CustomRugSizeModal.prototype.validatePhoneField = function (options) {
    options = options || {};
    var showError = options.showError !== false;

    if (!this.phoneInput) return true;

    var value = this.phoneInput.value.trim();
    if (!value) {
      this.clearFieldError('phone');
      return true;
    }

    if (PHONE_PATTERN.test(value)) {
      this.clearFieldError('phone');
      return true;
    }

    if (showError) this.showPhoneFieldError();
    return false;
  };

  CustomRugSizeModal.prototype.getFullPhoneNumber = function () {
    if (!this.phoneInput || !this.phoneInput.value.trim()) return '';
    if (!this.iti) return this.phoneInput.value.trim();

    var number = this.iti.getNumber();
    if (number) return number;

    var country = this.iti.getSelectedCountryData();
    var digits = this.getPhoneDigits();
    if (digits && country && country.dialCode) {
      return '+' + country.dialCode + digits;
    }

    return this.phoneInput.value.trim();
  };

  CustomRugSizeModal.prototype.initAddressSearch = function () {
    this.addressInput = this.form.querySelector('[data-custom-rug-address-input]');
    this.addressSuggestions = this.form.querySelector('[data-custom-rug-address-suggestions]');
    this.addressSearchHint = this.form.querySelector('[data-custom-rug-address-hint]');
    this.mapboxToken = (this.config.mapboxAccessToken || '').trim();

    if (this.addressSearchHint) {
      this.addressSearchHint.hidden = !this.mapboxToken;
    }
  };

  CustomRugSizeModal.prototype.queueAddressSearch = function (query) {
    var self = this;
    clearTimeout(this.addressSearchTimer);

    if (!this.mapboxToken || this.isUsMainland() || !this.addressInput || !this.addressSuggestions) {
      this.hideAddressSuggestions();
      return;
    }

    if (query.length < 3) {
      this.hideAddressSuggestions();
      return;
    }

    this.addressSearchTimer = setTimeout(function () {
      self.fetchAddressSuggestions(query);
    }, 300);
  };

  CustomRugSizeModal.prototype.fetchAddressSuggestions = function (query) {
    var self = this;
    var requestId = ++this.addressSearchRequestId;
    var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
      encodeURIComponent(query) +
      '.json?access_token=' + encodeURIComponent(this.mapboxToken) +
      '&autocomplete=true&types=address,place,locality,postcode&limit=5&language=en';

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Mapbox request failed');
        return res.json();
      })
      .then(function (data) {
        if (requestId !== self.addressSearchRequestId) return;
        self.renderAddressSuggestions(data.features || []);
      })
      .catch(function () {
        if (requestId !== self.addressSearchRequestId) return;
        self.hideAddressSuggestions();
      });
  };

  CustomRugSizeModal.prototype.parseMapboxFeature = function (feature) {
    var details = {
      placeName: feature.place_name || '',
      addressLine: feature.text || '',
      city: '',
      region: '',
      postcode: '',
      country: ''
    };

    if (feature.address) {
      details.addressLine = feature.address + ' ' + feature.text;
    }

    (feature.context || []).forEach(function (item) {
      if (item.id.indexOf('postcode.') === 0) {
        details.postcode = item.text;
      } else if (item.id.indexOf('place.') === 0) {
        details.city = item.text;
      } else if (item.id.indexOf('locality.') === 0 && !details.city) {
        details.city = item.text;
      } else if (item.id.indexOf('region.') === 0) {
        details.region = item.text;
      } else if (item.id.indexOf('country.') === 0) {
        details.country = item.text;
      }
    });

    return details;
  };

  CustomRugSizeModal.prototype.renderAddressSuggestions = function (features) {
    var self = this;
    if (!this.addressSuggestions || !this.addressInput) return;

    this.addressSuggestions.innerHTML = '';

    if (!features.length) {
      this.hideAddressSuggestions();
      return;
    }

    features.forEach(function (feature, index) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.id = 'custom-rug-address-option-' + index;

      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = feature.place_name || feature.text || '';
      button.addEventListener('click', function () {
        self.selectAddressSuggestion(feature);
      });

      li.appendChild(button);
      self.addressSuggestions.appendChild(li);
    });

    this.addressSuggestions.hidden = false;
    this.addressInput.setAttribute('aria-expanded', 'true');
  };

  CustomRugSizeModal.prototype.selectAddressSuggestion = function (feature) {
    if (!this.addressInput) return;

    this.addressDetails = this.parseMapboxFeature(feature);
    this.addressInput.value = this.addressDetails.placeName;
    this.clearFieldError('shipping-address');
    this.hideAddressSuggestions();
  };

  CustomRugSizeModal.prototype.hideAddressSuggestions = function () {
    if (!this.addressSuggestions) return;

    this.addressSuggestions.hidden = true;
    this.addressSuggestions.innerHTML = '';
    if (this.addressInput) {
      this.addressInput.setAttribute('aria-expanded', 'false');
    }
  };

  CustomRugSizeModal.prototype.getShippingAddressText = function () {
    if (this.addressDetails && this.addressDetails.placeName) {
      return this.addressDetails.placeName;
    }

    var input = this.form.querySelector('#custom-rug-shipping-address');
    return input ? input.value.trim() : '';
  };

  CustomRugSizeModal.prototype.getPrice = function (width, length) {
    if (!width || !length) return null;
    if (this.isWidthExceedsLength(width, length)) return null;
    var key = width + 'x' + length;
    return this.priceTable[key] != null ? this.priceTable[key] : null;
  };

  CustomRugSizeModal.prototype.isWidthExceedsLength = function (width, length) {
    if (!width || !length) return false;
    return parseInt(width, 10) > parseInt(length, 10);
  };

  CustomRugSizeModal.prototype.showWidthLengthError = function () {
    var err = this.form.querySelector('.custom-rug-size-field__error--width-length');
    if (err) err.hidden = false;
    var widthSelect = this.form.querySelector('[data-custom-rug-width]');
    if (widthSelect) widthSelect.setAttribute('aria-invalid', 'true');
  };

  CustomRugSizeModal.prototype.hideWidthLengthError = function () {
    var err = this.form.querySelector('.custom-rug-size-field__error--width-length');
    if (err) err.hidden = true;
    var widthSelect = this.form.querySelector('[data-custom-rug-width]');
    if (widthSelect) widthSelect.removeAttribute('aria-invalid');
  };

  CustomRugSizeModal.prototype.isUsMainland = function () {
    var cb = this.form.querySelector('[data-custom-rug-us-mainland]');
    return cb ? cb.checked : true;
  };

  CustomRugSizeModal.prototype.toggleAddressField = function () {
    var wrap = this.form.querySelector('[data-custom-rug-address-wrap]');
    if (!wrap) return;
    wrap.hidden = this.isUsMainland();
    if (this.isUsMainland()) {
      this.hideAddressSuggestions();
    }
  };

  CustomRugSizeModal.prototype.onSizeChange = function () {
    this.clearFieldError('length');
    this.clearFieldError('width');
    this.updateEstimate();
  };

  CustomRugSizeModal.prototype.updateEstimate = function () {
    var length = this.form.querySelector('[data-custom-rug-length]').value;
    var width = this.form.querySelector('[data-custom-rug-width]').value;
    var estimateEl = this.modal.querySelector('[data-custom-rug-estimate]');
    var estimateText = this.modal.querySelector('[data-custom-rug-estimate-text]');
    var comboError = this.form.querySelector('[data-field="length"] .custom-rug-size-field__error--combo');

    if (!length || !width) {
      estimateEl.hidden = true;
      if (comboError) comboError.hidden = true;
      this.hideWidthLengthError();
      return;
    }

    if (this.isWidthExceedsLength(width, length)) {
      estimateEl.hidden = true;
      if (comboError) comboError.hidden = true;
      this.showWidthLengthError();
      return;
    }

    this.hideWidthLengthError();

    var price = this.getPrice(width, length);
    if (price == null) {
      estimateEl.hidden = true;
      if (comboError) comboError.hidden = false;
      return;
    }

    if (comboError) comboError.hidden = true;
    estimateEl.hidden = false;

    if (this.isUsMainland()) {
      estimateText.innerHTML = formatCopy(getCopy(this.config, 'estimateUs'), { price: '<strong>' + price + '</strong>' });
    } else {
      estimateText.innerHTML = formatCopy(getCopy(this.config, 'estimateIntl'), { price: '<strong>' + price + '</strong>' });
    }
  };

  CustomRugSizeModal.prototype.open = function () {
    var sizeChart = document.querySelector('.exit-pop-size-chart-wrapper');
    var sizeChartOverlay = document.querySelector('.exit-pop-size-chart-overlay');
    if (sizeChart) {
      sizeChart.classList.remove('active');
      sizeChart.hidden = true;
    }
    if (sizeChartOverlay) {
      sizeChartOverlay.classList.remove('active');
      sizeChartOverlay.hidden = true;
    }
    document.body.classList.remove('exit-pop-size-chart-open');

    this.modal.hidden = false;
    this.overlay.hidden = false;
    requestAnimationFrame(function () {
      this.modal.classList.add('is-active');
      this.overlay.classList.add('is-active');
    }.bind(this));

    document.body.classList.add('custom-rug-size-open');
    this.goToStep('intro');
    this.ensurePhoneInput();
    this.modal.querySelector('.custom-rug-size-modal__close').focus();
  };

  CustomRugSizeModal.prototype.close = function () {
    this.modal.classList.remove('is-active');
    this.overlay.classList.remove('is-active');
    document.body.classList.remove('custom-rug-size-open');

    var self = this;
    setTimeout(function () {
      self.modal.hidden = true;
      self.overlay.hidden = true;
      self.resetForm();
      self.goToStep('intro');
      if (self.lastTrigger) self.lastTrigger.focus();
    }, 250);
  };

  CustomRugSizeModal.prototype.goToStep = function (step) {
    this.currentStep = step;

    this.modal.querySelectorAll('[data-custom-rug-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-custom-rug-step') !== step;
    });

    this.modal.querySelectorAll('[data-custom-rug-footer]').forEach(function (el) {
      el.hidden = el.getAttribute('data-custom-rug-footer') !== step;
    });

    if (step === 'success') {
      var textEl = this.modal.querySelector('[data-custom-rug-success-text]');
      if (textEl) {
        if (this.isUsMainland()) {
          textEl.textContent = getCopy(this.config, 'successUs');
        } else {
          textEl.textContent = getCopy(this.config, 'successIntl');
        }
      }
    }

    if (step === 'form') {
      this.ensurePhoneInput();
    }
  };

  CustomRugSizeModal.prototype.resetForm = function () {
    this.form.reset();
    var usMainland = this.form.querySelector('[data-custom-rug-us-mainland]');
    if (usMainland) usMainland.checked = true;
    this.toggleAddressField();
    this.hideAddressSuggestions();
    this.addressDetails = null;
    if (this.iti) {
      this.iti.setNumber('');
      this.iti.setCountry('us');
    }
    this.hideSystemError();
    this.clearAllErrors();
    this.modal.querySelector('[data-custom-rug-estimate]').hidden = true;

    var faqToggle = this.modal.querySelector('[data-custom-rug-faq-toggle]');
    var faqPanel = this.modal.querySelector('[data-custom-rug-faq-panel]');
    if (faqToggle) faqToggle.setAttribute('aria-expanded', 'false');
    if (faqPanel) faqPanel.hidden = true;

    var submitBtn = this.getSubmitButton();
    this.setSubmitLoading(false);
    this.isSubmitting = false;
  };

  CustomRugSizeModal.prototype.getSubmitButton = function () {
    return this.modal.querySelector('[data-custom-rug-submit]') ||
      document.querySelector('[data-custom-rug-submit]');
  };

  CustomRugSizeModal.prototype.setSubmitLoading = function (loading) {
    var btn = this.getSubmitButton();
    if (!btn) return;

    if (loading) {
      if (!btn.dataset.originalText) {
        btn.dataset.originalText = btn.textContent.trim();
      }
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
      btn.textContent = 'Submitting...';
      return;
    }

    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    btn.classList.remove('is-loading');
    if (btn.dataset.originalText) {
      btn.textContent = btn.dataset.originalText;
    }
  };

  CustomRugSizeModal.prototype.showFieldError = function (field) {
    var wrap = this.form.querySelector('[data-field="' + field + '"]');
    if (!wrap) return;
    var err = wrap.querySelector('.custom-rug-size-field__error:not(.custom-rug-size-field__error--combo)');
    if (err) err.hidden = false;
    var input = this.getFieldInput(field);
    if (input) input.setAttribute('aria-invalid', 'true');
  };

  CustomRugSizeModal.prototype.clearFieldError = function (field) {
    var wrap = this.form.querySelector('[data-field="' + field + '"]');
    if (!wrap) return;
    if (field === 'phone') wrap.classList.remove('has-error');
    wrap.querySelectorAll('.custom-rug-size-field__error').forEach(function (err) {
      err.hidden = true;
    });
    var input = this.getFieldInput(field);
    if (input) input.removeAttribute('aria-invalid');
  };

  CustomRugSizeModal.prototype.clearAllErrors = function () {
    var self = this;
    ['first-name', 'email', 'phone', 'shipping-address', 'length', 'width'].forEach(function (f) {
      self.clearFieldError(f);
    });
    var comboError = this.form.querySelector('.custom-rug-size-field__error--combo');
    if (comboError) comboError.hidden = true;
    this.hideWidthLengthError();
  };

  CustomRugSizeModal.prototype.fieldHasError = function (fieldName) {
    var wrap = this.form.querySelector('[data-field="' + fieldName + '"]');
    if (!wrap || wrap.hidden) return false;

    var hasVisibleError = Array.prototype.some.call(
      wrap.querySelectorAll('.custom-rug-size-field__error'),
      function (err) { return !err.hidden; }
    );
    var input = this.getFieldInput(fieldName);
    var hasInvalid = input && input.getAttribute('aria-invalid') === 'true';

    return hasVisibleError || hasInvalid;
  };

  CustomRugSizeModal.prototype.getFirstInvalidField = function () {
    var fields = ['first-name', 'email', 'phone', 'shipping-address', 'length', 'width'];

    for (var i = 0; i < fields.length; i++) {
      if (this.fieldHasError(fields[i])) return fields[i];
    }

    return null;
  };

  CustomRugSizeModal.prototype.scrollToElement = function (el, options) {
    options = options || {};
    var modalBody = this.modal.querySelector('.custom-rug-size-modal__body');
    if (!modalBody || !el) return;

    var bodyRect = modalBody.getBoundingClientRect();
    var elRect = el.getBoundingClientRect();
    var scrollTop = elRect.top - bodyRect.top + modalBody.scrollTop - 16;

    modalBody.scrollTo({
      top: Math.max(0, scrollTop),
      behavior: 'smooth'
    });

    if (options.focus) {
      window.setTimeout(function () {
        options.focus.focus({ preventScroll: true });
      }, 350);
    }
  };

  CustomRugSizeModal.prototype.scrollToField = function (fieldName) {
    var wrap = this.form.querySelector('[data-field="' + fieldName + '"]');
    if (!wrap || wrap.hidden) return;

    var focusTarget = this.getFieldInput(fieldName);
    this.scrollToElement(wrap, { focus: focusTarget });
  };

  CustomRugSizeModal.prototype.scrollToSystemError = function () {
    var el = this.modal.querySelector('[data-custom-rug-system-error]');
    if (!el || el.hidden) return;
    this.scrollToElement(el);
  };

  CustomRugSizeModal.prototype.scrollToFirstError = function () {
    var fieldName = this.getFirstInvalidField();
    if (fieldName) {
      this.scrollToField(fieldName);
      return;
    }

    this.scrollToSystemError();
  };

  CustomRugSizeModal.prototype.validate = function () {
    var valid = true;
    this.clearAllErrors();

    var firstName = this.form.querySelector('#custom-rug-first-name').value.trim();
    var email = this.form.querySelector('#custom-rug-email').value.trim();
    var length = this.form.querySelector('[data-custom-rug-length]').value;
    var width = this.form.querySelector('[data-custom-rug-width]').value;
    var address = this.getShippingAddressText();

    if (!firstName) {
      this.showFieldError('first-name');
      valid = false;
    }

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this.showFieldError('email');
      valid = false;
    }

    if (!this.validatePhoneField({ showError: true })) {
      valid = false;
    }

    if (!length) {
      this.showFieldError('length');
      valid = false;
    }

    if (!width) {
      this.showFieldError('width');
      valid = false;
    }

    if (length && width && this.isWidthExceedsLength(width, length)) {
      this.showWidthLengthError();
      valid = false;
    }

    if (length && width && !this.isWidthExceedsLength(width, length) && this.getPrice(width, length) == null) {
      var comboError = this.form.querySelector('.custom-rug-size-field__error--combo');
      if (comboError) comboError.hidden = false;
      valid = false;
    }

    if (!this.isUsMainland() && !address) {
      this.showFieldError('shipping-address');
      valid = false;
    }

    return valid;
  };

  CustomRugSizeModal.prototype.buildBody = function () {
    var firstName = this.form.querySelector('#custom-rug-first-name').value.trim();
    var lastName = this.form.querySelector('#custom-rug-last-name').value.trim();
    var email = this.form.querySelector('#custom-rug-email').value.trim();
    var length = this.form.querySelector('[data-custom-rug-length]').value;
    var width = this.form.querySelector('[data-custom-rug-width]').value;
    var notes = this.form.querySelector('#custom-rug-notes').value.trim();
    var marketing = this.form.querySelector('[name="marketing_opt_in"]').checked;
    var usMainland = this.isUsMainland();
    var address = this.getShippingAddressText();
    var price = this.getPrice(width, length);
    var fullName = lastName ? firstName + ' ' + lastName : firstName;
    var phone = this.getFullPhoneNumber();

    var lines = [
      '--- Custom Rug Size Request ---',
      'Form type: custom_rug_size',
      'Product: ' + (this.config.productTitle || ''),
      'Product URL: ' + (this.config.productUrl || ''),
      'Name: ' + fullName,
      'Email: ' + email,
      'Marketing opt-in: ' + (marketing ? 'Yes' : 'No'),
      'US mainland: ' + (usMainland ? 'Yes' : 'No'),
      'Size: ' + width + 'ft x ' + length + 'ft (Width x Length)',
      'Price estimate: $' + (price != null ? price : 'N/A')
    ];

    if (phone) {
      lines.splice(6, 0, 'Phone: ' + phone);
    }

    if (!usMainland && address) {
      lines.push('Shipping address: ' + address);
      if (this.addressDetails) {
        if (this.addressDetails.country) lines.push('Country: ' + this.addressDetails.country);
        if (this.addressDetails.city) lines.push('City: ' + this.addressDetails.city);
        if (this.addressDetails.region) lines.push('State/Province: ' + this.addressDetails.region);
        if (this.addressDetails.postcode) lines.push('Postal code: ' + this.addressDetails.postcode);
      }
    }

    if (notes) {
      lines.push('', 'Notes:', notes);
    }

    return lines.join('\n');
  };

  CustomRugSizeModal.prototype.showSystemError = function () {
    var el = this.modal.querySelector('[data-custom-rug-system-error]');
    if (!el) return;
    el.hidden = false;

    var self = this;
    requestAnimationFrame(function () {
      self.scrollToSystemError();
    });
  };

  CustomRugSizeModal.prototype.hideSystemError = function () {
    var el = this.modal.querySelector('[data-custom-rug-system-error]');
    if (el) el.hidden = true;
  };

  CustomRugSizeModal.prototype.syncToKlaviyo = function (email, firstName, lastName) {
    var listId = this.config.klaviyoListId;
    if (!listId) {
      console.warn('Klaviyo List ID is not configured.');
      return;
    }

    var formData = new FormData();
    formData.append('g', listId);
    formData.append('email', email);
    formData.append('$fields', '$first_name, $last_name, $source');
    formData.append('$first_name', firstName || '');
    formData.append('$last_name', lastName || '');
    formData.append('$source', 'Custom Rug Size Modal');

    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      body: formData
    }).catch(function(err) {
      console.error('Klaviyo sync error:', err);
    });
  };

  CustomRugSizeModal.prototype.submit = function () {
    var self = this;
    if (this.isSubmitting) return;
    if (!this.validate()) {
      var self = this;
      requestAnimationFrame(function () {
        self.scrollToFirstError();
      });
      return;
    }

    this.hideSystemError();
    this.isSubmitting = true;
    this.setSubmitLoading(true);

    var submitBtn = this.getSubmitButton();

    var firstName = this.form.querySelector('#custom-rug-first-name').value.trim();
    var lastName = this.form.querySelector('#custom-rug-last-name').value.trim();
    var email = this.form.querySelector('#custom-rug-email').value.trim();
    var marketing = this.form.querySelector('[name="marketing_opt_in"]').checked;
    var fullName = lastName ? firstName + ' ' + lastName : firstName;
    var phone = this.getFullPhoneNumber();

    if (this.fullPhoneInput) {
      this.fullPhoneInput.value = phone;
    }

    var formData = new FormData();
    var tokenInput = this.form.querySelector('[name="authenticity_token"]');
    if (tokenInput) formData.append('authenticity_token', tokenInput.value);
    formData.append('form_type', 'contact');
    formData.append('utf8', '✓');
    formData.append('contact[name]', fullName);
    formData.append('contact[email]', email);
    formData.append('contact[body]', this.buildBody());

    fetch('/contact', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'text/html' },
      redirect: 'follow'
    })
      .then(function (response) {
        if (response.redirected) {
          if (response.url.indexOf('contact_posted=true') !== -1) {
            self.goToStep('success');
            if (marketing) self.syncToKlaviyo(email, firstName, lastName);
            return null;
          }
          if (response.url.indexOf('/challenge') !== -1) {
            window.location.href = response.url;
            return null;
          }
        }

        return response.text().then(function (html) {
          if (
            html.indexOf('form-posted-success') !== -1 ||
            html.indexOf('form-status--success') !== -1 ||
            html.indexOf('post_success') !== -1 ||
            html.indexOf('contact_posted=true') !== -1
          ) {
            self.goToStep('success');
            if (marketing) self.syncToKlaviyo(email, firstName, lastName);
          } else {
            self.showSystemError();
          }
        });
      })
      .catch(function () {
        self.showSystemError();
      })
      .finally(function () {
        self.isSubmitting = false;
        self.setSubmitLoading(false);
      });
  };

  ready(function () {
    if (!document.querySelector('[data-custom-rug-modal]')) return;
    window.__customRugModal = new CustomRugSizeModal();
  });
})();
